import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getBusinessType as _getBusinessType, create, edit } from '@/api/setting/business';
export default {
  name: 'business-form',
  props: {
    id: {},
    onlyReady: {
      default: false
    }
  },
  data: function data() {
    return {
      rules: {
        n01Code: [{
          required: true,
          message: '请输入类型编码',
          trigger: 'change'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位类型编码'
        }],
        n01Name: [{
          required: true,
          message: '请输入业务名称',
          trigger: 'change'
        }],
        n01Risk: [{
          required: true,
          message: '请选择风险等级',
          trigger: 'change'
        }],
        n01RiskExplain: [{
          required: true,
          message: '请输入风险描述',
          trigger: 'change'
        }],
        n01QCLevel: [{
          required: true,
          message: '请选择质控层级',
          trigger: 'change'
        }],
        n01Tag: [{
          required: true,
          message: '请输入业务标签',
          trigger: 'change'
        }]
      },
      form: {
        disabled: false
      },
      prepend: 'BA',
      options: ['BA', 'BB', 'BC', 'BD', 'BE', 'BF'],
      loading: false
    };
  },
  methods: {
    getPrepend: function getPrepend(value) {
      this.prepend = value;
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var form, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, _yield$_this$$awaitTo3, _yield$_this$$awaitTo4, _err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this.onlyReady) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _this.$checkForm();
            case 2:
              _this.loading = true;
              form = _this.form;
              form.n01Available = form.disabled ? 'Y' : 'N';
              if (_this.id) {
                _context.n = 5;
                break;
              }
              _context.n = 3;
              return _this.$awaitTo(create(_objectSpread(_objectSpread({}, form), {}, {
                n01Code: "".concat(_this.prepend).concat(_this.form.n01Code)
              })));
            case 3:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              _context.n = 7;
              break;
            case 5:
              _context.n = 6;
              return _this.$awaitTo(edit(_objectSpread(_objectSpread({}, form), {}, {
                n01Code: "".concat(_this.prepend).concat(_this.form.n01Code)
              })));
            case 6:
              _yield$_this$$awaitTo3 = _context.v;
              _yield$_this$$awaitTo4 = _slicedToArray(_yield$_this$$awaitTo3, 1);
              _err = _yield$_this$$awaitTo4[0];
              _this.loading = false;
              if (!_err) {
                _context.n = 7;
                break;
              }
              return _context.a(2);
            case 7:
              _this.$message.success('操作成功');
              _this.$emit('submit');
            case 8:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getBusinessType: function getBusinessType() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_getBusinessTy, data, form;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _getBusinessType({
                code: _this2.id
              });
            case 1:
              _yield$_getBusinessTy = _context2.v;
              data = _yield$_getBusinessTy.data;
              form = data;
              form.disabled = !(form.n01Available === 'N');
              _this2.prepend = form.n01Code.replace(/[0-9]/g, '');
              form.n01Code = form.n01Code.replace(/\D/g, '');
              _this2.form = form;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.id) {
      this.getBusinessType();
    }
  }
};